export * from './HotelLocationContent'
